export const DOT_CHARACTER = '•';
